export default function Terms() {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.logo}>TxtMyCar</div>
        <h1 style={styles.title}>Terms &amp; Conditions</h1>
        <p style={styles.updated}>Last updated: February 2026</p>

        <div style={styles.content}>
          <section style={styles.section}>
            <h2 style={styles.h2}>1. About TxtMyCar</h2>
            <p>TxtMyCar is a trading name of Morgan Johnson Systems Ltd. TxtMyCar is a service that allows registered vehicle owners in the United Kingdom to receive SMS messages from other road users via their vehicle registration number. By creating an account, you agree to these Terms &amp; Conditions in full.</p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>2. Eligibility</h2>
            <p>You must be at least 18 years old to use TxtMyCar. By registering, you confirm that you are the registered keeper or authorised user of any vehicle you add to the service, and that the mobile number provided is one you own and consent to receive messages on.</p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>3. Acceptable Use</h2>
            <p>TxtMyCar is intended for legitimate, lawful communication between road users — for example, notifying someone their vehicle is blocking a driveway, or reporting a concern about a parked vehicle.</p>
            <p style={{ marginTop: 12 }}>You must not use TxtMyCar to:</p>
            <ul style={styles.list}>
              <li>Send threatening, abusive, harassing, or offensive messages</li>
              <li>Send unsolicited commercial or promotional messages (spam)</li>
              <li>Attempt to identify or locate individuals for any harmful purpose</li>
              <li>Impersonate another person or vehicle</li>
              <li>Violate any applicable UK law or regulation</li>
            </ul>
            <p style={{ marginTop: 12 }}>Users found to have sent abusive, threatening, or harassing messages will receive an initial seven day suspension. If abusive behaviour continues following reinstatement, the account will be permanently expelled. No refund or return of remaining credits will be made in respect of expelled accounts.
</p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>4. Credits &amp; Payments</h2>
            <p>Sending a message costs 5 credits. Credits are purchased in bundles of 100 for £10.00. Credits are non-refundable and have no cash value. Payments are processed securely by Stripe. We do not store your card details.</p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>5. Vehicle Stickers</h2>
            <p>Upon registering your first vehicle, you may receive a TxtMyCar sticker by post to the address provided. Stickers are provided free of charge, subject to availability. We cannot guarantee delivery timescales.</p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>6. Privacy &amp; Data</h2>
            <p>Your personal data is handled in accordance with our <a href="/privacy" style={styles.link}>Privacy Policy</a>. We do not sell or share your personal data with third parties except as required to operate the service (e.g. sending SMS via Twilio, processing payments via Stripe).</p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>7. Limitation of Liability</h2>
            <p>TxtMyCar is provided "as is". We do not guarantee uninterrupted service and accept no liability for any loss or damage arising from use of the service, including the content of messages sent or received through the platform. The sender of any message is solely responsible for its content.</p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>8. Changes to These Terms</h2>
            <p>We may update these Terms from time to time. Continued use of the service after changes are posted constitutes acceptance of the new Terms. We will notify registered users of significant changes by email.</p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>9. Governing Law</h2>
            <p>TxtMyCar is a trading name of Morgan Johnson Systems Ltd, a company registered in Scotland.
</p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>10. Contact</h2>
            <p>If you have any questions about these Terms, please contact us at <a href="mailto:hello@txtmycar.co.uk" style={styles.link}>hello@txtmycar.co.uk</a>.</p>
          </section>
        </div>

        <div style={styles.footer}>
          <a href="/signup" style={styles.link}>&larr; Back to sign up</a>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page:       { minHeight: '100vh', background: '#0f0f13', color: '#f0f0f4', fontFamily: "'DM Sans', sans-serif", padding: '40px 20px' },
  container:  { maxWidth: 720, margin: '0 auto' },
  logo:       { fontFamily: 'Syne, sans-serif', fontSize: 20, fontWeight: 800, color: '#e8ff47', marginBottom: 32 },
  title:      { fontFamily: 'Syne, sans-serif', fontSize: 36, fontWeight: 800, letterSpacing: -1, marginBottom: 8 },
  updated:    { color: '#7a7a94', fontSize: 14, marginBottom: 40 },
  content:    { lineHeight: 1.8, fontSize: 15 },
  section:    { marginBottom: 36, borderBottom: '1px solid #2a2a38', paddingBottom: 36 },
  h2:         { fontFamily: 'Syne, sans-serif', fontSize: 18, fontWeight: 700, color: '#e8ff47', marginBottom: 12 },
  list:       { paddingLeft: 20, marginTop: 8, lineHeight: 2, color: '#c0c0d0' },
  link:       { color: '#e8ff47', textDecoration: 'none' },
  footer:     { marginTop: 40, paddingTop: 24, borderTop: '1px solid #2a2a38' },
};
